import * as React from "react";
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { ManageBlacklistProps, ManageBlacklistState, ManageBlacklistHandler } from './manageblacklistcomponent';
import { ManageBlacklistCSSStyleImpl } from './manageblacklistcss';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { MemberDetailsViewModelImpl } from '../../groups/managegroup/membersdetails/memberdetailsviewmodel';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';
import { GroupButtonCSSStyleImpl } from '../../groups/managegroup/groupbuttoncss';
import { VerticalListComponent } from '../../../../toolkit/verticallist/verticallistcomponent';

export interface ManageBlacklistMemberHandler
{
  onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void;
  onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void;
}

export class ManageBlacklistView extends UIComponentViewImpl<UIDataModel> implements ManageBlacklistMemberHandler
{
  private viewModel: MemberDetailsViewModelImpl;
  private popupComponent: PopUpWrapperComponent;
  
  constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
  {
      super(applicationContext, uiComponentHandler);

      this.onAddMemberClicked = this.onAddMemberClicked.bind(this);
      this.onDeleteMemberClicked = this.onDeleteMemberClicked.bind(this);
      this.viewModel = new MemberDetailsViewModelImpl(5, applicationContext, this);
  }

    bindHandlers()
    {
      this.onCancelClicked = this.onCancelClicked.bind(this);
      this.onSaveClicked = this.onSaveClicked.bind(this);
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
    }

    draw(uiProps: ManageBlacklistProps, uiState: ManageBlacklistState, cssStyle: ManageBlacklistCSSStyleImpl): JSX.Element 
    {
        super.draw(uiProps, uiState, cssStyle);

        return this.getCreateBlacklistCSS(uiProps, uiState, cssStyle);
    }

    getCreateBlacklistCSS(uiProps: ManageBlacklistProps, uiState: ManageBlacklistState, cssStyle: ManageBlacklistCSSStyleImpl): JSX.Element 
    {
      this.viewModel.setListDatas(uiState.listOfBlacklistMembers);
      this.viewModel.setManageGroupType(uiState.manageBlacklistType);
      
      return (
        <div style={cssStyle.getWrapperCSSStyle()}>
          <label style={cssStyle.getBlacklistTitleCSSStyle()}>{uiProps.context.getResources().getString(Strings.add_number)}</label>

          <div style={cssStyle.getBlacklistMembersCSSStyle()}>
          {
              <VerticalListComponent listViewModel={this.viewModel} context={uiProps.context}/>}
          </div>
          <div style={{width: "65%", minWidth: "300px",display: "inline-block"}}>
          <div style={{display: "flex", flexFlow: "row wrap", paddingLeft: "8%",}}>
            <div style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onSaveClicked} style={new ButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.save)}/>
              </div>
              
              <div style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onCancelClicked} style={new GroupButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.cancel)}/>
            </div>
          </div>
          </div>
          <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={uiProps.context}/>
        </div>  
     );
    }

    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
      console.log("onDeleteClicked: " + memberDetailsDto.getMemberName());

      if(this.viewModel.getListOfDatas().length === 2)
      {
         this.showPopup(this.getContext().getResources().getString(Strings.please_add_atleast_one_member_to_blacklist), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else
      {
        (this.getUIComponentHandler() as ManageBlacklistHandler).onDeleteMemberClicked(memberDetailsDto);
      }
    }

    onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
      console.log("onAddMemberClicked: " + memberDetailsDto.getMsisdn());

      if(memberDetailsDto.getMemberName().length === 0)
      {
         this.showPopup(this.getContext().getResources().getString(Strings.member_name_is_mandatory), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else if(memberDetailsDto.getMsisdn().length  === 0)
      {
        this.showPopup(this.getContext().getResources().getString(Strings.mobile_number_is_mandatory), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else
      {

        console.log("-------blacklist: " + JSON.stringify((this.getUIProps() as ManageBlacklistProps).listOfBlacklistMembers));
        let isExists = (this.getUIProps() as ManageBlacklistProps).listOfBlacklistMembers.findIndex((t: MemberDetailsDto)=>
        {
            return t.getMsisdn() === memberDetailsDto.getMsisdn();
        });

          if(isExists === -1)
          {
            isExists = this.viewModel.getListOfDatas().findIndex((t: MemberDetailsDto)=>
            {
                return t.getMsisdn() === memberDetailsDto.getMsisdn();
            });
            
            if(isExists === -1)
            {
              (this.getUIComponentHandler() as ManageBlacklistHandler).onAddMemberClicked(memberDetailsDto);
            }
            else
            {
              this.showPopup(this.getContext().getResources().getString(Strings.mobile_number_must_be_unique), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
            }
          }
          else
          {
            this.showPopup(this.getContext().getResources().getString(Strings.already_added_as_member), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
          }
      }
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }

    hidePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }

    private onCancelClicked()
    {
      (this.getUIProps() as ManageBlacklistProps).onCancelClicked();
    }

    private onSaveClicked()
    {
        if((this.getUIState() as ManageBlacklistState).listOfBlacklistMembers.length === 1)
        {
          this.showPopup(this.getContext().getResources().getString(Strings.please_add_atleast_one_member_to_your_group), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
        }
        else
        {

          // (this.getUIState() as ManageBlacklistState).listOfBlacklistMembers.shift();
          (this.getUIComponentHandler() as ManageBlacklistHandler).onCreateBlacklistClicked();
          
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/manageblacklist/manageblacklistview.tsx